import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import adminAxios from "@/lib/axios";
import { handleApiError } from "@/lib/utils";

export interface ISpecialisationCarouselPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  design_variant?: string;

  title?: string;
  title_color?: string;
  subtitle?: string;
  subtitle_color?: string;
  background_color?: string;

  card_background_color?: string;
  card_title_color?: string;
  card_arrow_color?: string;
  card_icon_color?: string;

  show_navigation?: boolean;
  nav_arrow_color?: string;
  nav_prev_icon?: string;
  nav_prev_icon_alt?: string;
  nav_next_icon?: string;
  nav_next_icon_alt?: string;

  show_pagination?: boolean;
  scroll_active_color?: string;
  scroll_inactive_color?: string;
  scrollbar_thumb_color?: string;
  scrollbar_track_color?: string;
  show_scrollbar?: boolean;

  show_cta?: boolean;
  cta_text?: string;
  cta_text_color?: string;
  cta_background_color?: string;
  cta_shadow_color?: string;
  cta_icon?: string;
  cta_icon_alt?: string;
  cta_url?: string;

  modal_header_background_color?: string;
  modal_title_color?: string;
  modal_body_background_color?: string;
  modal_heading_color?: string;
  modal_text_color?: string;
  modal_close_icon_color?: string;
  modal_close_icon?: string;
  modal_close_icon_alt?: string;
  modal_primary_cta_text?: string;
  modal_primary_cta_text_color?: string;
  modal_primary_cta_background_color?: string;
  modal_primary_cta_icon?: string;
  modal_primary_cta_icon_alt?: string;
  modal_brochure_cta_text?: string;
  modal_brochure_cta_text_color?: string;
  modal_brochure_cta_background_color?: string;
  modal_brochure_cta_border_color?: string;
  modal_brochure_cta_icon?: string;
  modal_brochure_cta_icon_alt?: string;

  metadata?: unknown[];
  status?: boolean;
}

export async function createSpecialisationCarousel(
  payload: Partial<ISpecialisationCarouselPayload>,
) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.SPECIALISATION_CAROUSEL.CREATE,
      payload,
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateSpecialisationCarousel(
  id: number,
  payload: Partial<ISpecialisationCarouselPayload>,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.SPECIALISATION_CAROUSEL.UPDATE(id),
      payload,
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
